// Core component
import { Typography } from "./Typography";

// Variants
import { H1, H2, H3 } from "./variants/Heading";
import { Caption } from "./variants/Caption";
import { Link } from "./variants/Link";

Typography.H1 = H1;
Typography.H2 = H2;
Typography.H3 = H3;
Typography.Caption = Caption;
Typography.Link = Link;

export { Typography };